// extracted by mini-css-extract-plugin
export default {"form-wrapper":"EmailLoginForm_form-wrapper__4QeEZ","text-button":"EmailLoginForm_text-button__YFl0B","link":"EmailLoginForm_link__TrBmK"};